import { Component } from '@angular/core';
import { AEmptyBasePage } from '../empty.base.page';

@Component({
    selector: 'app-empty-ci',
    templateUrl: '../empty.base.page.html',
    styleUrls: ['../empty.base.page.css']
})
export class EmptyCiPage extends AEmptyBasePage {
    constructor() {
        super();
        this.pageTitleKey = '@@CISettingsPageTitle';
        this.pageDescriptionKey = '@@CISettingsPageDescription';
        this.settingItems = [
            {
                icon: 'pi pi-pencil',
                titleKey: '@@Themen',
                descriptionKey: '@@ThemenDesc',
                link: '/settings/ci/theme'
            },
            {
                icon: 'pi pi-th-large',
                titleKey: '@@Icons',
                descriptionKey: '@@IconsDesc',
                link: '/settings/ci/icons'
            },
            {
                icon: 'pi pi-font',
                titleKey: '@@Schriftarten',
                descriptionKey: '@@SchriftartenDesc',
                link: '/settings/ci/fonts'
            },
            {
                icon: 'pi pi-code',
                titleKey: '@@CSSVariable',
                descriptionKey: '@@CSSVariableDesc',
                link: '/settings/ci/cssvar'
            },
            {
                icon: 'pi pi-list',
                titleKey: '@@CSSClasses',
                descriptionKey: '@@CSSClassesDesc',
                link: '/settings/ci/cssclass'
            },
            {
                icon: 'pi pi-sliders-h',
                titleKey: '@@ControlStyles',
                descriptionKey: '@@ControlStylesDesc',
                link: '/settings/ci/controlStyles'
            },
            {
                icon: 'pi pi-chart-pie',
                titleKey: '@@ChartPalette',
                descriptionKey: '@@ChartPaletteDesc',
                link: '/settings/ci/chartpalette'
            },
            {
                icon: 'pi pi-desktop',
                titleKey: '@@AppBuilder',
                descriptionKey: '@@AppBuilderDesc',
                link: '/settings/ci/appbuilder'
            },
            {
                icon: 'pi pi-tag',
                titleKey: '@@MetaTags',
                descriptionKey: '@@MetaTagsDesc',
                link: '/settings/ci/tags'
            }
        ];
    }
}
